import React, { useState } from 'react';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  CoreLink,
  View,
} from '@uncinc/react-drupal-core';

import './style.scss';

const RelevantContent = (props) => {
  const {
    title,
    text,
    linkTitle,
    linkUrl,
    viewId,
    viewDisplayBlock,
    viewFilters,
  } = props;

  const [componentVisible, setComponentVisible] = useState(true);

  const onViewLoaded = (size) => {
    if (size === 0) {
      setComponentVisible(false);
    }
  };

  return componentVisible && (
    <div className="RelevantContent">
      <Container>
        <div className="row">

          <div className="col-12">
            <div className="RelevantContent__title">
              <h2>{title}</h2>
            </div>
            <div className="RelevantContent__text">
              <WysiwygField
                property="schema:text"
                html={text}
              />
            </div>
          </div>
        </div>

      </Container>

      <View
        id={viewId}
        filters={viewFilters}
        display={viewDisplayBlock}
        callback={onViewLoaded}
      />

      <Container>
        <div className="row">

          <div className="col-12">
            <div className="RelevantContent__link">
              <CoreLink className="Button Button--secondary" to={linkUrl}>
                {linkTitle} <i className="icon icon-arrow-right" />
              </CoreLink>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default RelevantContent;
